import type { ScorerWaitList, ScorerWaitRow } from '../../lib/scorer-wait-list';

export function ScorerWaitLists({ list, onSelect, disabled = false }: { list?: ScorerWaitList; onSelect: (row: ScorerWaitRow) => void; disabled?: boolean }) {
 const grouped = (rows: ScorerWaitRow[]) => {
  const groups = new Map<string, ScorerWaitRow[]>();
  for (const row of rows) groups.set(row.teamId, [...(groups.get(row.teamId) ?? []), row]);
  return [...groups].map(([id, people]) => <div key={id} className="space-y-1">
   <h3 className="font-semibold">{people[0].teamName}</h3>
   {people.map(row => <button key={row.shooterId} type="button" disabled={disabled} onClick={() => onSelect(row)} className="block min-h-12 w-full rounded px-3 py-2 text-left text-[var(--color-accent)] disabled:opacity-50">
    <span className="block font-medium">{row.name}</span><span className="block text-sm">{row.bib ?? 'No number'} · Lane {row.lane} · {row.shotsSaved}/{list?.shotsPlanned} shots</span>
   </button>)}
  </div>);
 };
 return <>
  <section aria-label="Waiting for scores" className="space-y-3 rounded-[var(--radius-lg)] border border-[var(--color-border)] p-4">
   <h2 className="font-semibold">Waiting for scores ({list?.waiting.length ?? 0})</h2>
   {grouped(list?.waiting ?? [])}
   {!list?.waiting.length ? <p className="text-sm text-[var(--color-text-secondary)]">No shooters waiting for scores.</p> : null}
  </section>
  <details className="space-y-3 rounded-[var(--radius-lg)] border border-[var(--color-border)] p-4">
   <summary className="cursor-pointer font-semibold">Round {list?.round ?? 1} complete ({list?.complete.length ?? 0})</summary>
   {grouped(list?.complete ?? [])}
  </details>
 </>;
}
